import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerBacker } from '../backer/backer.types';
import { ConsumerFamily, ConsumerFamilyChild } from './families.types';

const useCreateConsumerFamily = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const createConsumerFamily = async ({ name }: { name: string }) => {
    const { data } = await BackerApi.post<{ family: ConsumerFamily }>('/consumer/families', {
      family: { name },
    });
    return data;
  };
  return useMutation({
    mutationFn: createConsumerFamily,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.families.all });
    },
  });
};

const useCreateConsumerFamilyBacker = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const createConsumerFamilyBacker = async ({
    familyId,
    backer,
  }: {
    familyId: string;
    backer: Partial<ConsumerBacker>;
  }) => {
    const { data } = await BackerApi.post<ConsumerFamily>(
      `/consumer/families/${familyId}/backers`,
      {
        backer,
      }
    );
    return data;
  };
  return useMutation({
    mutationFn: createConsumerFamilyBacker,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.families.all });
    },
  });
};

const useCreateConsumerFamilyChild = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const createConsumerFamilyChild = async ({
    familyId,
    child,
  }: {
    familyId: string;
    child: Pick<ConsumerFamilyChild, 'first_name' | 'last_name' | 'cause_ids'>;
  }) => {
    const { data } = await BackerApi.post<ConsumerFamily>(
      `/consumer/families/${familyId}/children`,
      {
        child,
      }
    );
    return data;
  };
  return useMutation({
    mutationFn: createConsumerFamilyChild,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.families.all });
    },
  });
};

export { useCreateConsumerFamily, useCreateConsumerFamilyBacker, useCreateConsumerFamilyChild };
